module.exports = __webpack_public_path__ + "img/manage.5da95d36.jpg";